import { render } from "./NavigationComponent.vue?vue&type=template&id=b371e892&ts=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=ts"
export * from "./NavigationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__